var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkCard',{attrs:{"to":_vm.to,"external":_vm.external}},[_c('img',{staticClass:"icon-card",attrs:{"src":'/icons/' + _vm.icon + '.svg'}})])}
var staticRenderFns = []

export { render, staticRenderFns }